import {useEffect, useRef} from 'react';
import logger from '../../../services/logger';
import {matrixService} from '../../../services/matrixService';
import {getActiveDirectCall} from '../../../services/matrixCallService';
import {decideCallEscalation} from '../../../services/matrixCalling/callEscalation';
import {callEscalation} from './callEscalationService';

interface CallEscalationEvent {
    readonly content: unknown;
    readonly roomId: string;
    readonly senderId: string;
    readonly eventId: string;
}

export const useCallEscalationListener = (enabled: boolean, expanded: boolean): void => {
    const expandedRef = useRef(expanded);
    expandedRef.current = expanded;

    useEffect(() => {
        if (!enabled) {
            return;
        }
        const onEscalation = (event: CallEscalationEvent) => {
            const decision = decideCallEscalation({
                content: event.content,
                senderId: event.senderId,
                roomId: event.roomId,
                localUserId: matrixService.getClient()?.getUserId() ?? null,
                active: getActiveDirectCall(),
                now: Date.now(),
            });
            if (decision.kind !== 'follow') {
                logger.debug('Call escalation ignored', {source: 'call_escalation', event: 'ignored', reason: decision.reason, eventId: event.eventId});
                return;
            }
            logger.info('Following call escalation', {source: 'call_escalation', event: 'follow', groupRoomId: decision.content.room_id, eventId: event.eventId});
            void callEscalation.follow(decision.content, event.senderId, expandedRef.current).then(outcome => {
                logger.info('Call escalation followed', {source: 'call_escalation', event: 'followed', outcome, groupRoomId: decision.content.room_id});
            });
        };
        matrixService.on('callEscalation', onEscalation);
        return () => {
            matrixService.off('callEscalation', onEscalation);
        };
    }, [enabled]);
};
